import CheckIcon from '@mui/icons-material/Check'
import WarningIcon from '@mui/icons-material/Warning'
import LocalMallIcon from '@mui/icons-material/LocalMall'
import { useAlert } from 'providers/AlertProvider'
import { ActionAlert, StyledSnackbar } from './Alert.styled'

export const Alert = () => {
  const { type, text, open, anchorPosition, onClick } = useAlert()

  const getIcon = () => {
    if (type === 'success') {
      return <CheckIcon fontSize='inherit' />
    }
    if (type === 'notification') {
      return <LocalMallIcon fontSize='inherit' />
    }
    return <WarningIcon fontSize='inherit' />
  }

  return (
    <StyledSnackbar
      open={open}
      autoHideDuration={4000}
      anchorOrigin={anchorPosition}
      onClick={onClick}>
      <ActionAlert
        icon={getIcon()}
        type={type}
        sx={{
          cursor: onClick ? 'pointer' : 'default',
        }}>
        {text}
      </ActionAlert>
    </StyledSnackbar>
  )
}
